import { openWindow } from '@change-corgi/core/window';
import type { TrackingFn } from '@change-corgi/core-react/tracking';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { copyToClipboard } from '#src/app/shared/utils/clipboard';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

// eslint-disable-next-line max-params
export async function shareLine(
	url: string,
	text: string | undefined,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
	i18nContext: UtilityContext['i18n'],
): Promise<void> {
	// Message pre-population might not work on Android from a Facebook Web View. Copy to clipboard as a fallback option.
	// https://change.atlassian.net/browse/CHANGE-84268
	await copyToClipboard(url, i18nContext);
	const msg = encodeURIComponent(text ? `${text}\n${url}` : url);
	openWindow(`line://msg/text/${msg}`);
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
